export const API_ERROR_CODE = {
  "0": "",
  REQUIRE_PARAMETERS_INCLUDE_NULL: "E400001",
  BAD_REQUEST_PARAMETER: "E400002",
  NO_EXIST_IN_FMS: "E400003",
  INVALID_REQUEST_ENDPOINT: "E400004",
  FMS_PROJECT_ID_ALREADY_EXISTS: "E400019",
  FMS_PROJECT_ID_DOES_NOT_MATCH_COMPANY: "E400020",
  FAILED_TO_CONNECT_DATABASE: "E500001",
  FAILED_TO_GET_DATA: "E500002",
  FAILED_TO_UPDATE_DATABASE: "E500003",
  FAILED_TO_ISSUE_TOKEN: "E500004",
  FAILED_TO_EXECUTE_FMS_API: "E500005",
  FAILED_TO_CREATE_TASK_SCHEDULE: "E500006",
  FAILED_TO_ROLL_BACK_DATABASE: "E500007",
  FAILED_TO_ROLL_BACK_DATABASE_BY_TOKEN: "E500008",
  UNKNOWN_ERROR: "E500999",
};
